<template>
  <!-- 选择分公司 -->
  <div class="select-filiale">
    <el-dialog title="选择分公司" :visible.sync="dialogVisible"
               :before-close="closeDialog"
               :close-on-click-modal="false"
               :modal-append-to-body="false"
               width="600px">
      <div class="dialog-content">
        <el-input
          placeholder="输入关键字进行过滤"
          v-model="filterText">
        </el-input>
        <el-tree
          show-checkbox
          node-key="id"
          ref="dialogTree"
          :load="loadNode"
          lazy
          default-expand-all
          :default-checked-keys="(defaultCheckedKeys && selectList.length === 0) ? defaultCheckedKeys : []"
          :filter-node-method="filterNode"
          :check-strictly="selectType === 'single'?true:false"
          :check-on-click-node="true"
          :expand-on-click-node="false"
          :props="{ label: 'name', children: 'zones' }"
          @check-change="checkChange"
        ></el-tree>
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="dialog-operation">
          <div class="btn">
            <el-button @click="closeDialog">取消</el-button>
            <el-button type="primary" @click="saveSelectedMember">保存</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'select-filiale-dialog',
  props: ['dialogVisible', 'selectType', 'defaultCheckedKeys'],
  data () {
    return {
      selectList: [],
      filiale: '',
      filterText: ''
    }
  },
  watch: {
    dialogVisible (val) {
      if (val === true && this.$refs.dialogTree) {
        this.$refs.dialogTree.setCheckedKeys(this.selectList.map(e => e.id))
      }
    },
    filterText (val) {
      this.$refs.dialogTree.filter(val)
    }
  },
  methods: {
    loadNode (node, resolve) {
      if (node.level > 2) return resolve([])
      if (node.level === 0) {
        return resolve([{ id: '0005A41F-0000-0000-0000-0000FDA5314A', name: '总公司', parentId: '0005A41F-0000-0000-0000-0000FDA5314A' }])
      } else {
        this.$axios.get('/report-api/report/data/16AC44EA-3FD0-010B-CBD7-620855ADD70E', {
          params: {
            index: -1,
            size: 10,
            sort: '',
            filters: {'16AC46BB-7CD0-0128-55AA-17647A325B28': node.data.id}
          }
        }).then((res) => {
          let options = []
          let parentId = node.level === 1 ? '0005A41F-0000-0000-0000-0000FDA5314A' : node.data.id
          res.data.forEach(n => options.push({ id: n['16AC44F4-5A40-0110-E353-E98582A63C5A'], name: n['16AC44F4-C640-0112-238E-AE9C3FD7475C'], parentId: parentId }))
          return resolve(options)
        })
      }
    },
    // 过滤函数
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 节点选项变化处理，处理单选
    checkChange (data, checked) {
      if (this.selectType === 'single' && checked) {
        this.$refs.dialogTree.setCheckedKeys([data.id])
      }
    },
    getSelectList (list) {
      // 首先判断最上层节点是否勾选
      let parent = list.find(e => e.id === '0005A41F-0000-0000-0000-0000FDA5314A')
      if (parent) {
        this.filiale = parent.name
      } else {
        let arr = []
        // 节点下所有的子节点被勾选，才会勾选到父节点
        // 所有被勾选到父节点
        let parentIds = []
        list.forEach(e => {
          let item = list.find(x => x.id === e.parentId)
          if (item) {
            if (parentIds.findIndex(y => y.id === item.id) === -1) {
              parentIds.push({...item})
            }
          }
        })
        // 过滤父节点被勾选的子节点
        list.forEach(e => parentIds.findIndex(x => x.id === e.parentId) === -1 && arr.push({...e}))
        this.filiale = arr.map(e => e.name).join('、')
      }
      this.$emit('setFiliale', this.filiale)
    },
    closeDialog () {
      this.$emit('closeDialog')
    },
    saveSelectedMember () {
      this.selectList = [...this.$refs.dialogTree.getCheckedNodes()]
      this.getSelectList(this.$refs.dialogTree.getCheckedNodes())
      this.$emit('setSelectList', this.selectList)
    }
  }
}
</script>

<style lang="scss">
  .select-filiale{
    .dialog-content {
      height: 500px;
      overflow: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/custom/page/huaao/visualReport/publicDialog/select-filiale-dialog.vue